import _orderBy from 'lodash-es/orderBy';
import { policyTypeLabels, policyTypeNames } from '@ourbranch/lookups';
import { getInternalTaskState, internalTaskRegistry } from '@ourbranch/onboarding-tasks';

import { capitalize } from 'core/helpers/formatters';

// Policy IDs are `<accountId>-<policyType><n>-<seq>-<state>` (e.g. `311581272-home2-001-OH`). The policy type
// here is that ID form (`home`, `auto`, `cond`, `rent`), not the H/A code; it comes from `policyTypeLabels`, so
// that map's key order is the display order.
const policyTypeOrder = Object.values(policyTypeLabels);

export const getPolicyType = (policyId) => policyId?.split('-')[1]?.replace(/[0-9]+$/, '');

export const getPolicyTypeName = (policyType) => {
  const [code] = Object.entries(policyTypeLabels).find(([, label]) => label === policyType) || [];
  return policyTypeNames[code] || capitalize(policyType);
};

const policyTypeRank = (policyId) => {
  const rank = policyTypeOrder.indexOf(getPolicyType(policyId));
  return rank === -1 ? policyTypeOrder.length : rank;
};

export const sortTasksByPolicy = (tasks) => _orderBy(tasks, [(task) => policyTypeRank(task.policyId), 'policyId']);

export const TaskStatus = {
  Incomplete: 'incomplete',
  Submitted: 'submitted',
  Approved: 'approved'
};

// A task has no stored status: the row badge and the status cards both derive it from these two dates.
export const getTaskStatus = ({ completedDate, approvalDate }) => {
  if (approvalDate) {
    return TaskStatus.Approved;
  }
  if (completedDate) {
    return TaskStatus.Submitted;
  }
  return TaskStatus.Incomplete;
};

const internalStateToStatus = {
  pending: TaskStatus.Incomplete,
  needsReview: TaskStatus.Submitted,
  approved: TaskStatus.Approved
};

export const getInternalTaskStatus = (task) =>
  internalStateToStatus[getInternalTaskState(task, internalTaskRegistry[task.taskName])];
